import React, { useCallback } from "react";
import { Skeleton, Space } from "antd";

import { ChatItem } from "./ChatItem";
import { useScrollBottomHandler } from "../../../utils/dom";
import {
  Root,
  NoChats,
  ChatItemContainer,
  ChatDelimiter,
  LoaderContainer
} from "./styles";
import { IFulfilledChat } from "../../../interfaces/interfacesChat";
import { LoadingIndicator } from "../../LoadingIndicator";
import { useTranslation } from "react-i18next";

interface IChatsList {
  chats: IFulfilledChat[];
  onChatClick: (chat: IFulfilledChat) => void;
  onScrollBottom?: () => void;
  selectedChatId?: string | null;
  isLoading?: boolean;
  isLoadingNextPage?: boolean;
  filter: string;
}

export const ChatsList = React.memo<IChatsList>(
  ({
    chats,
    selectedChatId,
    onChatClick,
    onScrollBottom,
    isLoading,
    isLoadingNextPage,
    filter
  }) => {
    const scrollContainerRef = useScrollBottomHandler({
      handler: useCallback(() => {
        onScrollBottom?.();
      }, [onScrollBottom])
    });

    const { t } = useTranslation("chats");
    return (
      <Root ref={scrollContainerRef}>
        {!isLoading && chats.length === 0 ? (
          <NoChats>
            {filter
              ? t("chatList.filterMessage1")
              : t("chatList.filterMessage2")}
          </NoChats>
        ) : null}
        {isLoading ? (
          <Space style={{ width: "100%" }} direction="vertical" size="large">
            <Skeleton avatar active />
            <Skeleton avatar active />
            <Skeleton avatar active />
          </Space>
        ) : (
          chats.map((chat) => (
            <ChatItemContainer key={chat.chat_id}>
              <ChatItem
                chat={chat}
                onClick={onChatClick}
                isSelected={selectedChatId === chat.chat_id}
              />
              <ChatDelimiter />
            </ChatItemContainer>
          ))
        )}
        {isLoadingNextPage && (
          <LoaderContainer>
            <LoadingIndicator />
          </LoaderContainer>
        )}
      </Root>
    );
  }
);
